import type { SiteRef } from './types';

/** Fără diacritice și majuscule, ca „Brasov” să fie găsit în „Brașov”. */
const plain = (s: string) =>
  s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

/**
 * Locul de livrare scris în mail, pe pagina furnizorului și pe comandă. Adresa
 * cu localitatea (furnizorul socotește transportul după oraș), dacă adresa nu
 * are deja orașul; fără adresă, numele șantierului cu localitatea.
 */
export function deliveryLine(site: Pick<SiteRef, 'name' | 'locality' | 'address'>): string {
  const address = site.address.trim();
  const locality = site.locality.trim();
  if (!address) return [site.name.trim(), locality].filter(Boolean).join(', ');
  // „Brașov, BV”: ajunge ca orașul să fie în adresă
  const city = locality.split(',')[0]!.trim();
  if (!city || plain(address).includes(plain(city))) return address;
  return `${address}, ${locality}`;
}

/** Numele șantierului cu localitatea, pentru liste și antete. */
export function siteLabel(site: Pick<SiteRef, 'name' | 'locality'>): string {
  const locality = site.locality.trim();
  return locality ? `${site.name} · ${locality}` : site.name;
}
